"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerAppFinalizeActionRequestToJSON = exports.SignerAppFinalizeActionRequestFromJSONTyped = exports.SignerAppFinalizeActionRequestFromJSON = exports.instanceOfSignerAppFinalizeActionRequest = exports.attributeTypeMapSignerAppFinalizeActionRequest = void 0;
var runtime_1 = require("../runtime");
var FieldSaveJoined_1 = require("./FieldSaveJoined");
exports.attributeTypeMapSignerAppFinalizeActionRequest = [
    {
        name: "guid",
        type: "string",
    },
    {
        name: "data",
        type: "{ [key: string]: FieldSaveJoined; }",
    },
    {
        name: "isSmsDelivery",
        type: "boolean",
    },
    {
        name: "accessCode",
        type: "string",
    },
    {
        name: "shouldRedirect",
        type: "boolean",
    },
];
/**
 * Check if a given object implements the SignerAppFinalizeActionRequest interface.
 */
function instanceOfSignerAppFinalizeActionRequest(value) {
    if (!("guid" in value) || value["guid"] === undefined)
        return false;
    if (!("data" in value) || value["data"] === undefined)
        return false;
    if (!("isSmsDelivery" in value) || value["isSmsDelivery"] === undefined)
        return false;
    return true;
}
exports.instanceOfSignerAppFinalizeActionRequest = instanceOfSignerAppFinalizeActionRequest;
function SignerAppFinalizeActionRequestFromJSON(json) {
    return SignerAppFinalizeActionRequestFromJSONTyped(json, false);
}
exports.SignerAppFinalizeActionRequestFromJSON = SignerAppFinalizeActionRequestFromJSON;
function SignerAppFinalizeActionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        guid: json["guid"],
        data: (0, runtime_1.mapValues)(json["data"], FieldSaveJoined_1.FieldSaveJoinedFromJSON),
        isSmsDelivery: json["is_sms_delivery"],
        accessCode: json["access_code"] == null ? undefined : json["access_code"],
        shouldRedirect: json["should_redirect"] == null ? undefined : json["should_redirect"],
    };
}
exports.SignerAppFinalizeActionRequestFromJSONTyped = SignerAppFinalizeActionRequestFromJSONTyped;
function SignerAppFinalizeActionRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        guid: value["guid"],
        data: (0, runtime_1.mapValues)(value["data"], FieldSaveJoined_1.FieldSaveJoinedToJSON),
        is_sms_delivery: value["isSmsDelivery"],
        access_code: value["accessCode"],
        should_redirect: value["shouldRedirect"],
    };
}
exports.SignerAppFinalizeActionRequestToJSON = SignerAppFinalizeActionRequestToJSON;
